import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';


import I18n from 'PMT/i18n/I18n';

import { Restaurant } from 'PMT/entities';
import { OrderSettings } from 'PMT/entities/order';
import KioskOrderTicketSettings from 'PMT/entities/restaurant/KioskOrderTicketSettings';

//
// components
//
import TextareaInput from 'PMT/components/form/TextareaInput';
import FormGroupView from 'PMT/components/form/FormGroupView';
import TipTooltip from 'PMT/components/TipTooltip';

export default class KioskTicketView extends Component {

  static propTypes = {
    restaurant: PropTypes.instanceOf(Restaurant).isRequired,

    orderSettings: PropTypes.instanceOf(OrderSettings).isRequired,

    ticketSettings: PropTypes.instanceOf(KioskOrderTicketSettings).isRequired,

    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool.isRequired,
  };

  //
  //
  //

  parseCustomTextLines = (lines) => {
   _.forEach(lines, (line, i) => {
      if (line.length > 40) {
        lines[i] = line.substr(0, 40);
        lines.splice(i + 1, 0, line.substr(40));
        lines = this.parseCustomTextLines(lines);
      } else {
        lines[i] = line;
      }
    });

    return lines;
  }

  onCustomTextChange = (customText: string) => {
    const ticketSettings = this.props.ticketSettings;
    let lines = customText.split("\n");

    lines = this.parseCustomTextLines(lines)
    customText = lines.join("\n");
    ticketSettings.customText = customText;

    this.props.onChange(ticketSettings);
  };

  //
  // Renderers
  //

  renderTicketCustomText() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.kiosk.ticket.custom_label')}
          <TipTooltip
            text={I18n.tr('order.settings.kiosk.ticket.custom_label.tooltip')}
          />
        </FormGroupView.Label>
        <FormGroupView.Content>
          <TextareaInput
            rows={10}
            onChange={this.onCustomTextChange}
            value={this.props.ticketSettings.customText}
            readOnly={this.props.readOnly}
            max={KioskOrderTicketSettings.CUSTOM_TEXT_MAX_LENGTH}
          />
        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  renderTicketLabels() {
    return (
      <FormGroupView>
        <FormGroupView.Label>
          {I18n.tr('order.settings.kiosk.ticket.custom_field.label')}
        </FormGroupView.Label>
        <FormGroupView.Content>

        </FormGroupView.Content>
      </FormGroupView>
    );
  }

  render() {
    try {
    return (
      <div>
        <h3
          className="text-center"
        >
          {I18n.tr('order.settings.kiosk.ticket.title')}
        </h3>
        {this.renderTicketCustomText()}
        {/* {this.renderTicketLabels()} */}
      </div>
    );
  } catch (e) { console.error(e)}
  }

}
